import { render } from "./search_neibu.vue?vue&type=template&id=3640be89"
import script from "./search_neibu.vue?vue&type=script&lang=js"
export * from "./search_neibu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Shared/Previously Relocated Items/Security/data/www/solo/CyReport/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__